import React from 'react'
import { Edit } from 'react-admin'
import MatchcenterForm from './form'

export const MatchcenterEdit = (props) => (
  <Edit undoable={false} {...props}>
    <MatchcenterForm {...props} />
  </Edit>
)

export default MatchcenterEdit
